import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';

export const GET_CAMPAIGN_STATUS = gql`
  query GetCampaignStatus($campaignId: String!) {
    thomasCampaign(campaign_id: $campaignId) {
      status_id
    }
  }
`;

interface CampaignStatusContainerRenderProps {
  statusId: number;
}

interface CampaignStatusContainerProps {
  campaignId: string;
  children: (props: CampaignStatusContainerRenderProps) => any;
}
const CampaignStatusContainer: React.FC<CampaignStatusContainerProps> = ({
  campaignId,
  children,
  ...props
}: CampaignStatusContainerProps) => (
  <Query<any>
    query={GET_CAMPAIGN_STATUS}
    variables={{ campaignId }}
    fetchPolicy="network-only"
    pollInterval={30000}
  >
    {({
      data: { thomasCampaign } = {
        thomasCampaign: {} as any
      },
      loading
    }) => {
      if (loading) {
        return null;
      }
      const statusId = thomasCampaign.status_id;
      return (
        children &&
        children({
          ...props,
          statusId
        })
      );
    }}
  </Query>
);

export default CampaignStatusContainer;
